import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as UnavailableIcon } from '../../../assets/images/openingUnavailableIcon.svg';

import styles from './OpeningUnavailable.module.scss';

const OpeningUnavailable = () => {
  const { t } = useTranslation('common');
  return (
    <div className={styles.container}>
      <UnavailableIcon />
      <h3 className={styles.header}>{t('browse.pageNotFound')}</h3>
      <p className={styles.content}>{t('browse.openingUnavailable')}</p>
    </div>
  );
};

export default OpeningUnavailable;
